import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import DriverListLayer from "../components/DriverListLayer";

const DriverListPage = () => {
  return (
    <MasterLayout>
      <DriverListLayer />
    </MasterLayout>
  );
};

export default DriverListPage;
